import { Instagram, Phone, Telegram, WhatsApp } from '@mui/icons-material';
import { Box, Button, styled, Typography } from '@mui/material';

const Contact = () => {
  return (
    <Box sx={{ mb: 4, maxWidth: '100%', textAlign: 'center' }}>
      {/* Banner Text */}
      <Typography
        variant="h5"
        sx={{
          fontWeight: 'bold',
          letterSpacing: '1px',
          color: '#ffffff',
          mb: 1,
          textShadow: '1px 1px 5px rgba(0, 0, 0, 0.2)',
        }}
      >
        КОНТАКТЫ
      </Typography>

      {/* Icons Section */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-around',
          alignItems: 'center',
          mb: 4,
          maxWidth: '100%',
          margin: '0 auto',
          height: '30vh',
          color: '#4CAF50',
        }}
      >
        {/* Contacts (Phone) Icon with Label */}
        <Box sx={{ textAlign: 'center' }}>
          <a href="tel:+996705130070" target="_blank" rel="noopener noreferrer">
            <Phone sx={{ fontSize: '40px', color: '#4CAF50' }} />
          </a>
          <Typography variant="body2" sx={{ color: '#6c757d', mt: 1 }}>
            Контакты
          </Typography>
        </Box>

        {/* Instagram Icon with Label */}
        <Box sx={{ textAlign: 'center' }}>
          <a
            href="https://www.instagram.com/game.zone.kg/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Instagram sx={{ fontSize: '40px', color: '#E1306C' }} />
          </a>
          <Typography variant="body2" sx={{ color: '#6c757d', mt: 1 }}>
            Instagram
          </Typography>
        </Box>

        {/* Telegram Icon with Label */}
        <Box sx={{ textAlign: 'center' }}>
          <a
            href="https://t.me/+996705130070"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Telegram sx={{ fontSize: '40px', color: '#0088cc' }} />
          </a>
          <Typography variant="body2" sx={{ color: '#6c757d', mt: 1 }}>
            Telegram
          </Typography>
        </Box>

        {/* WhatsApp Icon with Label */}
        <Box sx={{ textAlign: 'center' }}>
          <a
            href="https://wa.me/996705130070?text=Здравствуйте, хотел(а) забронировать зал..."
            target="_blank"
            rel="noopener noreferrer"
          >
            <WhatsApp sx={{ fontSize: '40px', color: '#25D366' }} />
          </a>
          <Typography variant="body2" sx={{ color: '#6c757d', mt: 1 }}>
            WhatsApp
          </Typography>
        </Box>
      </Box>

      {/* Address Text */}
      <a
        href="https://2gis.kg/bishkek/firm/70000001036343765/74.587768%2C42.867311?m=74.587996%2C42.867305%2F20"
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'none' }} // Remove underline from the link
      >
        <Typography
          variant="body1"
          sx={{
            color: '#ffffff', // Dark muted color
            mt: 4, // Larger top margin for spacing
            fontWeight: '600',
            letterSpacing: '0.8px',
            textShadow: '1px 1px 5px rgba(0, 0, 0, 0.1)',
            position: 'relative',
            fontSize: '1.4rem',
            '::before': {
              content: '""',
              display: 'block',
              width: '50%',
              height: '2px',
              backgroundColor: '#ced4da',
              position: 'absolute',
              top: '-12px', // Position the line above the text
              left: '25%', // Center the line
            },
          }}
        >
          Манаса 5 Бишкек
        </Typography>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'transform 0.3s ease', // Add transition for the Box
            '&:hover': {
              transform: 'scale(1.01)', // Scale up on hover
            },
          }}
        >
          <StyledButton color="primary">Построить маршрут</StyledButton>
        </Box>
      </a>
    </Box>
  );
};

export default Contact;

const StyledButton = styled(Button)(({ theme }) => ({
  width: '100%',
  marginTop: theme.spacing(1),
  fontWeight: 600,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1, 1),
  textTransform: 'none',
  color: theme.palette.primary.contrastText,
  background: 'linear-gradient(135deg, #750fb4, #750fb4)',
  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
  transition: 'all 0.3s ease',
  '&:hover': {
    background: 'linear-gradient(135deg, #600896d2, #600896d2)',
    boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.2)',
  },
}));
